/* eslint-disable no-restricted-globals */
import moment from 'moment';
import 'moment/locale/pt-br';

import dateize from '@sdk/helpers/formatters/dateize';
import { DATE_FORMAT_CHARS } from '@cordel/helpers/form/validators/date';

moment.locale('pt-br');
moment.suppressDeprecationWarnings = true;

export function dateParams(value = '', options = {}) {
  const format = options.format || DATE_FORMAT_CHARS;

  return dateize(value, {
    format,
  }) ? [value, format] : [undefined, format];
}

export function subtractDate(value = null, options = {}) {
  const [
    extractedDate,
    extractedFormat,
  ] = dateParams(value, options);

  return moment(extractedDate)
    .subtract(options.months || 0, 'months')
    .subtract(options.years || 0, 'years')
    .format(extractedFormat);
}

export function extractDate(value = null, options = {}) {
  const currentDate = moment(...dateParams(value, options));

  const diff = moment.duration(moment().diff(currentDate));
  const years = diff.years();
  const months = diff.months();

  return {
    years: isNaN(years) ? 0 : years,
    months: isNaN(months) ? 0 : months,
  };
}

export default dateize;
